export enum AttendanceStatusOption {
    AnyRecord = "AnyRecord",
    Unrecorded = "Unrecorded",
    PresentMakeup = "PresentMakeup",
    Present = "Present",
    PresentLate = "PresentLate",
    PresentLateMakeUp = "PresentLateMakeUp",
    AbsentMakeup = "AbsentMakeup",
    AbsentUseMakeup = "AbsentUseMakeup",
    AbsentNoMakeup = "AbsentNoMakeup",
    AbsentNotice = "AbsentNotice",
    TeacherAbsentMakeup = "TeacherAbsentMakeup",
    TeacherAbsentNoMakeup = "TeacherAbsentNoMakeup"
}